module.exports = __webpack_public_path__ + "img/SmartSalesLogo.efbdd463.png";